// extracted by mini-css-extract-plugin
export default {"dots":"Deivi2NTzpPA5a6dPvYP","cssload-shift":"QOxJskMUEJLlMP3a4l5Q","cssloadShift":"QOxJskMUEJLlMP3a4l5Q","dotsCenter":"KK34f6MOdJ3TsLYrlBf0"};